const pageHasEntryRestrictionDatesMap = document.querySelector("#EntryRestrictionDatesMap") != null;

if (pageHasEntryRestrictionDatesMap) {
    import(
        /* webpackChunkName: "entry-restriction-dates-map" */
        './mount'
    ).then(({ mountEntryRestrictionDatesMap }) => {
        mountEntryRestrictionDatesMap();
    });
}